import classNames from 'classnames';
import styles from './Loader.module.css';

interface Props {
  variant: 'light' | 'dark';
}

export function Loader({ variant }: Props) {
  return (
    <div className={classNames(styles.loader, styles[`variant-${variant}`])}>
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </div>
  );
}
